const getInitialState = (props)=>{
    const { purchaseType , defaultDeliveryInterval  } = props;
    return {
        configurations: {
            purchaseType,
            subscriptionPurchaseConfigurations: {
                deliveryInterval: defaultDeliveryInterval !== null && defaultDeliveryInterval !== void 0 ? defaultDeliveryInterval : null
            },
            quantity: 1
        },
        configurator: {
            invalidSubmissionsCount: undefined,
            deliveryInterval: {
                showError: false
            }
        }
    };
};

export { getInitialState };
//# sourceMappingURL=get-initial-state.js.map
